var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2H29C30.625 2 32 3.375 32 5V27C32 28.6875 30.625 30 29 30H3C1.3125 30 0 28.6875 0 27V5C0 3.375 1.3125 2 3 2ZM29 28C29.5 28 30 27.5625 30 27V5C30 4.5 29.5 4 29 4H3C2.4375 4 2 4.5 2 5V27C2 27.5625 2.4375 28 3 28H29ZM22.0625 9C22.1875 9 22.4375 9.0625 22.5625 9.1875L27.8125 14.3125C27.9375 14.4375 28.0625 14.6875 28.0625 14.875C28.0625 15.0625 27.9375 15.25 27.8125 15.375L27.4375 15.75C27.3125 15.875 27.125 15.9375 26.9375 15.9375C26.75 15.9375 26.5 15.875 26.375 15.75L23.0625 12.5V22.4375C23.0625 22.75 22.8125 22.9375 22.5625 22.9375H21.5625C21.25 22.9375 21.0625 22.75 21.0625 22.4375V12.4375L17.6875 15.75C17.5625 15.875 17.3125 16 17.125 16C16.9375 16 16.75 15.875 16.625 15.75L16.25 15.375C16.125 15.25 16 15.0625 16 14.875C16 14.6875 16.125 14.4375 16.25 14.3125L21.5 9.1875C21.625 9.0625 21.875 9 22.0625 9ZM5 13.5C5 11.5 6.625 9.5 8.5625 9.0625C8.6875 9.0625 8.85938 9.04688 9.03125 9.03125C9.20312 9.01562 9.375 9 9.5 9C12 9 14 11 14.0625 13.5V16C14 19.5625 11.125 22.6875 7.5625 22.9375C7.25 22.9375 7.0625 22.75 7.0625 22.4375V21.4375C7.0625 21.1875 7.25 21 7.5 20.9375C9.5625 20.75 11.25 19.3125 11.8125 17.3125C11.25 17.6875 10.1875 18 9.5625 18H9.5C7 18 5 16 5 13.5ZM7.0625 13.5C7.0625 14.875 8.125 16 9.5625 16C10.9375 16 12.0625 14.875 12.0625 13.5C12.0625 12.125 10.9375 11 9.5625 11C8.125 11 7.0625 12.125 7.0625 13.5Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi);
export default __webpack_public_path__ + "static/media/kpi.7ab1b174.svg";
export { ForwardRef as ReactComponent };